<script>
import { mapGetters } from 'vuex'

import ArticleCard from '@components/current-news/article-card.vue';
import Translatable from '@src/mixins/translatable.js'

export default {
  components: {
    ArticleCard,
  },
  mixins: [
    Translatable
  ],
  data() {
    return {
      articlesToDisplay: 4,
      initialDisplay: 4,
    }
  },
  computed: {
    ...mapGetters('currentNews', [
      'newsList'
    ]),
    displayedArticles() {
      // return this.newsList.slice(0, this.articlesToDisplay)
      return this.newsList.slice(0, 10)
    },
    btnLabel() {
      return this.newsList.length > this.articlesToDisplay ?
      this.getTranslatedContent('ARTICLE_show_more') : this.getTranslatedContent('ARTICLE_show_less')
    },
  },
  methods: {
    toggleArticles() {
      if (this.articlesToDisplay < this.newsList.length) {
        this.articlesToDisplay = this.articlesToDisplay + this.initialDisplay
      } else {
        this.articlesToDisplay = this.initialDisplay
      }
    }
  }
}
</script>

<template>
  <div class="section-container">
    <div class="content">
      <ArticleCard v-for="article in displayedArticles" :key="article._id" :article="article"/>
    </div>
    <!-- <div v-if="displayedArticles.length > initialDisplay" class="container">
      <div class="button-container" @click="toggleArticles">
        <button class="button">{{ btnLabel }}</button>
      </div>
    </div> -->
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.section-container {
  width: 1140px;
}

.content {
  display: grid;
  justify-items: center;
  row-gap: 65px;
  grid-template-columns: repeat(1, 1fr);
  margin-top: 30px;
}

.button-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  margin-top: 40px;
}

.button {
  width: 228px;
  height: 48px;
  background: $orange;
  border-radius: 5px;
  border: 1px solid $orange;
  text-transform: uppercase;
  font-family: Open Sans Bold, sans-serif;
  font-weight: bolder;
  font-style: normal;
  font-size: 15px;
  line-height: 19px;
  color: $white;

  &:hover {
    border: 1px solid $hover-orange;
    background: $hover-orange;
  }
}

@media only screen and (max-width: $container-width-xs) {
  .section-container, .button  {
    width: 100%;
  }

  .content {
    row-gap: 30px;
    margin-top: 20px;
  }
}
</style>
